export default __webpack_public_path__ + "static/media/logo-courts-of-denmark.4c344e10.svg";